import React from 'react';
import { FC } from 'react';
import { change, Field } from 'redux-form';
import { useDispatch } from 'react-redux';
import { FormLocationSearchTextInput } from 'components/form-inputs/form-location-search-text-input/form-location-search-text-input';
import { MapBoxPlace, PlaceSelectOptionValue } from 'logic/store/geolocation/geolocation.model';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Text } from 'components/text/Text';
import { OfferFormFields } from '../../pages-all/offer-form/offer-form.logic';
import { HeadingPublishOffer } from '../../pages-all/offer-form/components/common';
import { RegisterAsElitetutorAddressFormFields } from 'src/pages-all/register-as-elitetutor/forms/register-elitetutor-address-form.logic';

interface LocationInputProps {
  formName: string;
  formFields: typeof RegisterAsElitetutorAddressFormFields | typeof OfferFormFields;
  heading?: string;
  paragraph?: string;
}

export const LocationInput: FC<LocationInputProps> = ({
  formFields,
  formName,
  heading,
  paragraph,
}) => {
  const dispatch = useDispatch();

  const handleStreetChange = (placeValue: PlaceSelectOptionValue | undefined) => {
    dispatch(change(formName, formFields.postcode, placeValue?.context?.postcode?.text || null));
    dispatch(change(formName, formFields.place, placeValue?.context?.place?.text || null));
    dispatch(change(formName, formFields.region, placeValue?.context?.region?.text || null));
    dispatch(
      change(formName, formFields.country, placeValue?.context?.country?.short_code || null)
    );
    dispatch(change(formName, formFields.longitude, placeValue?.longitude || null));
    dispatch(change(formName, formFields.latitude, placeValue?.latitude || null));
  };

  return (
    <div>
      {heading && <HeadingPublishOffer level={2}>{heading}</HeadingPublishOffer>}
      {paragraph && (
        <div style={{ marginBottom: '20px', width: '100%' }}>
          <Text size={14} color="grey">
            {paragraph}
          </Text>
        </div>
      )}

      <Field
        name={formFields.address}
        component={FormLocationSearchTextInput}
        label={translate(translationKeys.publishOffer.location.street.label)}
        placeholder={translate(translationKeys.publishOffer.location.street.placeholder)}
        onLocationContextChange={handleStreetChange}
        valuePlace={MapBoxPlace.Street}
        searchPlaces={[MapBoxPlace.Street]}
      />

      <Field
        name={formFields.postcode}
        component={FormLocationSearchTextInput}
        label={translate(translationKeys.publishOffer.location.postcode.label)}
        placeholder={translate(translationKeys.publishOffer.location.postcode.placeholder)}
        disabled
        valuePlace={MapBoxPlace.Postcode}
        searchPlaces={[MapBoxPlace.Postcode]}
      />

      <Field
        name={formFields.place}
        component={FormLocationSearchTextInput}
        label={translate(translationKeys.publishOffer.location.city.label)}
        placeholder={translate(translationKeys.publishOffer.location.city.placeholder)}
        disabled
        valuePlace={MapBoxPlace.City}
        searchPlaces={[MapBoxPlace.City]}
      />

      <Field
        additionalAntFormItemStyles={{ marginBottom: '0' }}
        name={formFields.region}
        component={FormLocationSearchTextInput}
        label={translate(translationKeys.publishOffer.location.landRegion.label)}
        placeholder={translate(translationKeys.publishOffer.location.landRegion.placeholder)}
        disabled
        valuePlace={MapBoxPlace.Region}
        searchPlaces={[MapBoxPlace.Region]}
      />
    </div>
  );
};
